import * as React from "react";
import { styled, useTheme } from "@mui/system";
import MUISelect from "@mui/material/Select";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { SelectProps as SelectPropsMUI } from "@mui/material/Select";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type SelectProps = {
  readOnly?: boolean;
} & SelectPropsMUI;
export const Select: React.FC<SelectProps> = styled(
  React.forwardRef((props: SelectProps, ref: any) => {
    const theme = useTheme();
    return (
      <MUISelect
        IconComponent={
          theme.name === "fic"
            ? (props) => <FontAwesomeIcon icon={faCaretDown} {...props} />
            : KeyboardArrowDownIcon
        }
        sx={{
          "& legend": {
            display: "none"
          },
          "& .MuiOutlinedInput-notchedOutline": {
            top: 0
          }
        }}
        {...props}
        ref={ref}
      ></MUISelect>
    );
  }),
  {
    name: "Select",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "readOnly" && prop !== "disabled",
    overridesResolver: (props, styles) => [styles.root]
  }
)<{ readOnly?: boolean; disabled?: boolean }>(
  ({ theme, readOnly, disabled, size, error }) => ({
    "& .MuiInputBase-input.MuiOutlinedInput-input": {
      "&:read-only": {
        backgroundColor:
          readOnly || disabled
            ? theme.palette.primary.inputBackgroundReadonlyColor + " !important"
            : theme.palette.primary.inputBackgroundDefault + " !important"
      }
    },
    "& .MuiSvgIcon-root.MuiSelect-icon": {
      color: disabled
        ? theme.palette.primary.iconDisabled
        : theme.palette.primary.iconDefault
    },
    "& .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input":
      {
        textAlign: "left",
        paddingTop: size === "small" ? 6 : 10,
        paddingBottom: size === "small" ? 6 : 10,
        paddingRight: 30,
        paddingLeft: 8
      },
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.MuiSelect-select":
      {
        minHeight: 20
      },
    ...(theme.name === "fic" && {
      "& .MuiSelect-icon": {
        right: "14px"
      }
    })
  })
) as SelectComponent;

type SelectComponent = (
  props: SelectProps &
    React.RefAttributes<HTMLInputElement> & { component?: React.ElementType }
) => JSX.Element;
